import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@fnacdarty/back-office-ui';
import {
	getUser,
	renewToken,
	cleanSession,
} from '../features/authentication/utils/auth';

import expiredIllustration from '../assets/images/illustrations/man-listening-music.svg';

import { BrandHeadBar } from '../layouts';

const BaseFlexColumn = styled.div`
	display: flex;
	flex-direction: column;
`;
const BaseFlexCenter = styled(BaseFlexColumn)`
	align-items: center;
`;
const StyledContainer = styled(BaseFlexCenter)`
	justify-content: center;
	margin: 20px 20px 20px 20px;
	height: calc(100vh - 90px);
`;
const StyledHeader = styled(BaseFlexCenter)`
	width: 100%;
`;
const StyledContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const StyledOverflowText = styled.span`
	overflow: hidden;
`;
const StyledSecondaryButton = styled.button`
	background-color: ${(props) => props.theme.colors.background};
	padding: 10px;
	border-radius: 5px;
	border: 1px solid ${(props) => props.theme.colors.primary};
	width: 100%;
	color: ${(props) => props.theme.colors.primary};
	margin-top: 12px;
`;
const Expired = () => {
	const { firstName, lastName, token, refreshToken } = getUser();
	const [loading, setLoading] = useState(false);

	const handleRenewSession = async (newAccount = false) => {
		setLoading(true);
		const tmpToken = token;
		const tmpRefreshToken = refreshToken;
		const isSessionCleaned = await cleanSession(newAccount);

		if (!newAccount) {
			if (isSessionCleaned) {
				const user = await renewToken(tmpToken, tmpRefreshToken);

				setLoading(false);
				if (user) {
					window.location.href = '/';
				} else {
					await cleanSession(true);
				}
			}
		}
		setLoading(false);
		window.location.href = '/login';
	};
	return (
		<>
			<BrandHeadBar />
			<StyledContainer>
				<StyledHeader>
					<img
						width={200}
						style={{ height: 'auto' }}
						src={expiredIllustration}
						alt="expired"
					/>

					<Button
						style={{
							height: 'auto',
							fontSize: '14px',
							padding: '6px 18px',
						}}
						onClick={async () => {
							if (!loading) {
								await handleRenewSession(false);
							}
						}}
					>
						<StyledOverflowText>
							{!loading ? (
								<>
									Continuer en tant que
									<br />
									<b>
										{firstName} {lastName}
									</b>
								</>
							) : (
								'Chargement...'
							)}
						</StyledOverflowText>
					</Button>
					<span>OU</span>
					<StyledSecondaryButton
						onClick={() => {
							if (!loading) {
								handleRenewSession(true);
							}
						}}
					>
						Utiliser un autre compte
					</StyledSecondaryButton>
				</StyledHeader>
				<StyledContent />
			</StyledContainer>
		</>
	);
};

export default Expired;
